import { type Control, type UseFormWatch } from 'react-hook-form';
import { Box, Column } from '~/commonComponents';
import { Colors } from '~/themes/colors';
import { type IShiftDetailsFormValues } from '../ShiftDetailsForm/useShiftDetailsForm';
import { AutoConfirmField } from './AutoConfirmField';
import { InviteField } from './InviteField';

interface ISpeedUpCoverageSectionProps {
  control: Control<IShiftDetailsFormValues>;
  watch: UseFormWatch<IShiftDetailsFormValues>;
}

export const SpeedUpCoverageSection = ({
  control,
  watch,
}: ISpeedUpCoverageSectionProps) => {
  const professionType = watch('professionType');
  const preferredSpecialty = watch('preferredSpecialty');
  const officeId = watch('officeId');

  return (
    <Column data-testid="speed-up-coverage-section" gap={20}>
      <InviteField
        control={control}
        professionType={professionType}
        officeId={officeId}
      />

      <Box height={1.5} backgroundColor={Colors.neutral_100} />

      <AutoConfirmField
        control={control}
        professionType={professionType}
        preferredSpecialty={preferredSpecialty}
      />
    </Column>
  );
};
